import React, { useState } from "react";

const FeaturesSection = ({
  formData,
  handleAddFeature,
  handleRemoveFeature,
  errors = {},
}) => {
  const [featureDraft, setFeatureDraft] = useState("");

  const submitFeature = () => {
    const trimmedFeature = featureDraft.trim();
    if (!trimmedFeature) return;

    const featureAdded = handleAddFeature(trimmedFeature);
    if (featureAdded) {
      setFeatureDraft("");
    }
  };

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-4 pb-2 border-b">Features</h3>

      <div
        className={`border rounded-lg p-4 bg-slate-50 ${
          errors.features ? "border-red-400" : ""
        }`}
      >
        <label className="block mb-2 font-medium">Feature Description</label>
        <div className="flex gap-3 items-start">
          <input
            type="text"
            value={featureDraft}
            onChange={(event) => setFeatureDraft(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                submitFeature();
              }
            }}
            className="flex-1 border rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Write a feature description and click add"
          />
          <button
            type="button"
            onClick={submitFeature}
            className="px-4 py-2 bg-primary1 text-white rounded-lg whitespace-nowrap"
          >
            Add
          </button>
        </div>
        <p className="text-sm text-slate-500 mt-2">
          Add one feature description at a time.
        </p>
        {errors.features ? (
          <p className="mt-2 text-sm text-red-600">{errors.features}</p>
        ) : null}
      </div>

      <div
        className={`mt-4 border rounded-lg divide-y ${
          errors.features ? "border-red-400" : ""
        }`}
      >
        {Array.isArray(formData.features) && formData.features.length > 0 ? (
          formData.features.map((feature, index) => (
            <div
              key={`${feature}-${index}`}
              className="flex items-center justify-between gap-4 p-4"
            >
              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800">
                  Feature {index + 1}
                </p>
                <p className="text-sm text-slate-600 break-words">{feature}</p>
              </div>
              <button
                type="button"
                onClick={() => handleRemoveFeature(feature)}
                className="px-3 py-1.5 text-sm bg-red-50 text-red-600 rounded-lg hover:bg-red-100"
              >
                x
              </button>
            </div>
          ))
        ) : (
          <div className="p-4 text-sm text-slate-500 italic">
            No features added yet.
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturesSection;
